export enum UserRole {
  STUDENT = 'student',
  INSTRUCTOR = 'instructor',
  ENTERPRISE_ADMIN = 'enterprise_admin',
}
